import { put, all, call, takeEvery } from 'redux-saga/effects'
import {
  addLibraryPick,
  addLibraryPickSuccess,
  addLibraryPickFailed,
  appendLibraryPicks,
  requestLibraryPicks,
  requestLibraryPicksSuccess,
  requestLibraryPicksFailed,
  removeLibraryPick,
  removeLibraryPickSuccess,
  removeLibraryPickFailed,
  setHasMore
} from './LibraryPicksSlice'
import { notificationsEnqueue } from 'src/features/notifications/NotificationsSlice'
import { notificationDuration as duration } from 'src/constants'

function* fetchLibraryPicksRequest(services, { payload }) {
  const LibraryPicksRepository = services('LibraryPicksRepository')
  try {
    const { data, page, last_page } = yield call(
      [LibraryPicksRepository, 'getLibraryPicks'],
      payload
    )

    if (payload.append) {
      yield put(appendLibraryPicks(data))
    } else {
      yield put(requestLibraryPicksSuccess(data))
    }

    yield put(setHasMore(page < last_page))
  } catch (error) {
    yield put(
      requestLibraryPicksFailed(
        error.message || 'Failed to fetch library picks'
      )
    )
  }
}

function* addLibraryPickRequest(services, { payload }) {
  const LibraryPicksRepository = services('LibraryPicksRepository')
  try {
    const { articleId, companyId, siteId, OnRequestSuccess } = payload
    if (!articleId || !companyId || !siteId) {
      console.error('[LibraryPicksSaga] Missing required fields:', payload)
      yield put(addLibraryPickFailed('Missing required field in payload'))
      return
    }
    const data = yield call([LibraryPicksRepository, 'addLibraryPicks'], {
      articleId,
      companyId,
      siteId
    })

    yield put(addLibraryPickSuccess(data))
    yield put(
      notificationsEnqueue({
        message: 'Article has been added to Library Picks.',
        duration
      })
    )
    if (typeof OnRequestSuccess === 'function') {
      yield call(OnRequestSuccess, data?.id)
    }
  } catch (error) {
    console.error('[LibraryPicksSaga] Add Library Pick failed:', error)
    yield put(addLibraryPickFailed(error.message || 'Unknown error'))
  }
}

function* removeLibraryPickRequest(services, { payload }) {
  const LibraryPicksRepository = services('LibraryPicksRepository')
  const { libraryPickId, articleId, OnRequestSuccess } = payload

  if (!libraryPickId || !articleId) {
    yield put(removeLibraryPickFailed('Missing required field in payload'))
    return
  }

  try {
    yield call([LibraryPicksRepository, 'removeLibraryPick'], libraryPickId)
    yield put(removeLibraryPickSuccess({ libraryPickId }))
    yield put(
      notificationsEnqueue({
        message: 'Article has been removed from Library Picks.',
        duration
      })
    )
    if (typeof OnRequestSuccess === 'function') {
      yield call(OnRequestSuccess)
    }
  } catch (error) {
    yield put(removeLibraryPickFailed(error.message || 'Unknown error'))
  }
}

export default function* watchLibraryPicksRequest(services) {
  yield all([
    takeEvery(requestLibraryPicks, fetchLibraryPicksRequest, services),
    takeEvery(addLibraryPick, addLibraryPickRequest, services),
    takeEvery(removeLibraryPick, removeLibraryPickRequest, services)
  ])
}
